import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class BrandEndpoints {
  constructor(private http: HttpClient) {}
}
